import { hasOwnProperty } from 'utils/objects';

interface Action {
  type: string;
}

interface Handler<S> {
  <A extends Action>(state: S, action?: A): S;
}

const createReducer =
  <S>(initialState: S, handlers: Record<string, Handler<S>>) =>
  <A extends Action>(state = initialState, action?: A) => {
    if (action && hasOwnProperty(handlers, action.type)) {
      return handlers[action.type](state, action);
    }

    if (hasOwnProperty(handlers, '*')) {
      return handlers['*'](state, action);
    }

    return state;
  };

export default createReducer;

/*
Object.prototype.hasOwnProperty.call(handlers, action.type)
      ? handlers[action.type](state, action)
      : Object.prototype.hasOwnProperty.call(handlers, '*')
      ? handlers['*'](state, action)
      : state;
*/
